import usePrefStore from '../stores/prefs'
import useSalesStore from '../stores/sales'
import { db as dexie_db } from '../stores/db'
import { clearIdbStorage } from '../stores/idbStorage'

export type PurgeScope = { db?: boolean, orders?: boolean, cacheCollections?: boolean, cacheProducts?: boolean }

export const PURGE_ALL: PurgeScope = { db: true, orders: true, cacheCollections: true, cacheProducts: true }

/**
 * Purge de la base locale (portée de cleanDb de la page d'assistance, factorisée pour être
 * réutilisée par l'impersonation). Le login et le « se souvenir de moi » sont conservés ;
 * resetPrefs() conserve aussi l'état d'impersonation (cf. stores/prefs.ts).
 */
export async function purgeLocalData(scope: PurgeScope): Promise<void> {
   const sales = useSalesStore.getState()
   if (scope.db) {
      console.log('CleanDB')
      sales.setLastUpdatedBiOrders(null)
      sales.setLastUpdatedConfies(null)
      sales.setLastUpdatedConfiesRAL(null)
      sales.setLastUpdatedCustomers(null)
      sales.setLastUpdatedVentesRAL(null)
      await dexie_db.bi_orders.clear()
      await dexie_db.confies.clear()
      await dexie_db.confies_ral.clear()
      await dexie_db.customers.clear()
      await dexie_db.ventes_ral.clear()
      await clearIdbStorage()
   }
   if (scope.orders) {
      console.log('CleanOrders')
      sales.setLastUpdatedOrders(null)
      await dexie_db.orders.clear()
   }
   if (scope.cacheCollections) {
      console.log('CleanCacheCollections')
      await caches.delete('collections')
   }
   if (scope.cacheProducts) {
      console.log('CleanCacheProducts')
      await caches.delete('products')
   }
   if (scope.db || scope.orders) {
      const prefs = usePrefStore.getState()
      const remember = prefs.rememberMe
      const login = prefs.login
      prefs.reset()
      if (remember) {
         const p = usePrefStore.getState()
         p.setRememberMe(remember)
         p.setLogin(login)
      }
   }
}
